import React, { forwardRef } from 'react';
import Select from 'react-select';

export default forwardRef((props, ref) => {
  const attrs = { ...props };
  if (ref) attrs.ref = ref;

  return <Select {...attrs} />;
});
